import { getDatabase, ref, get, set, update } from "firebase/database";
import { app } from "../firebase";
import { formatDateKey } from "../utils/date";

const database = getDatabase(app);

export const getDateKey = () => formatDateKey(new Date());

export const getUsersByDate = async (dateKey) => {
  const snapshot = await get(ref(database, `users/${dateKey}`));
  if (!snapshot.exists()) return {};
  return snapshot.val();
};

export const findUserBySponsorId = async (sponsorId) => {
  const snapshot = await get(ref(database, "users"));
  if (!snapshot.exists()) return null;
  const usersByDate = snapshot.val();
  const target = sponsorId.trim().toLowerCase();

  for (const [dateKey, users] of Object.entries(usersByDate)) {
    if (!users || typeof users !== "object") continue;
    for (const [dbKey, user] of Object.entries(users)) {
      if (!user) continue;
      const id = (user.sponsorId || user.userId || "").toString().toLowerCase();
      if (id === target) {
        return { dateKey, dbKey, user };
      }
    }
  }
  return null;
};

export const getAdminAccount = async (dateKey) => {
  const snapshot = await get(ref(database, `admin/${dateKey}/adminAccount`));
  if (!snapshot.exists()) return null;
  return snapshot.val();
};

export const ensureAdminAccount = async (dateKey) => {
  const existing = await getAdminAccount(dateKey);
  if (existing) return existing;

  // create a skeleton admin account; password should be set immediately
  // via the ChangePassword UI. we avoid hardcoding a default password
  // to encourage secure setup.
  const adminAccount = {
    userId: "admin",
    role: "admin",
    email: "admin@gmail.com",
    password: "", // must be initialized by administrator
    mobile: "",
    otp: "",
    createdAt: new Date().toISOString(),
  };

  await set(ref(database, `admin/${dateKey}/adminAccount`), adminAccount);
  return adminAccount;
};

export const saveUserLogin = async ({ dateKey, dbKey, user, loginMeta }) => {
  const loginTime = new Date().toISOString();
  const loginHistory = Array.isArray(user.loginHistory) ? user.loginHistory : [];
  const nextHistory = [
    { loginTime, ...loginMeta },
    ...loginHistory,
  ].slice(0, 50);

  await update(ref(database, `users/${dateKey}/${dbKey}`), {
    lastLogin: loginTime,
    loginHistory: nextHistory,
  });
};
